import { render } from "./ReferralRockLeaderboard.vue?vue&type=template&id=1e3a1104"
import script from "./ReferralRockLeaderboard.vue?vue&type=script&lang=js"
export * from "./ReferralRockLeaderboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__